import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResponeObject } from 'src/app/models/socialpost.model';
import { AuthService, ResponseObject } from 'src/app/Services/auth.service';
import { GalleryConsignmentProduct } from 'src/app/Services/consignment.service';
import { ServiceBase } from 'src/app/Services/service.base';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SquareSpaceService extends ServiceBase {
  private api = '/SquareSpace';

  constructor(private http: HttpClient,
    authService: AuthService) {
    super(authService)
  }

  public getSquareupSyncProducts(): Observable<GalleryConsignmentProduct[]> {
    const httpOptions = this.RequestHeaders();
    const method: string = '/synced-products';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<GalleryConsignmentProduct[]>(url, httpOptions);
  }

  public hasAccountOnSquareSpace() {
    const httpOptions = this.RequestHeaders();
    const method: string = '/account-exists';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<ResponseObject>(url, httpOptions)
  }

  public squareSpaceAppInstallationLinkToConnectWithSquareSpace() {
    const httpOptions = this.RequestHeaders();
    const method: string = '/login-url';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<ResponeObject>(url, httpOptions);
  }

  public onDisconnectSquareSpaceAccount(id: string | null) {
    const httpOptions = this.RequestHeaders();
    const method: string = '/disconnect/' + id;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.put<ResponseObject>(url, {}, httpOptions);
  }

  public getSquareSpaceAccountDetails() {
    const httpOptions = this.RequestHeaders();
    const method: string = '/sites';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get(url, httpOptions);
  }

  public onSquareSpaceAccountCallBack(code: string, state: string) {
    const httpOptions = this.RequestHeaders();

    const encodedCode = encodeURIComponent(code);

    const method: string = `/auth/callback?code=${encodedCode}&state=${state}`;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.post<ResponeObject>(url, {}, httpOptions);
  }

  public getSquareSpaceStorePages(id: string) {
    const httpOptions = this.RequestHeaders();
    const method: string = `/${id}/store-pages`;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.post(url, {}, httpOptions);
  }

  public storeCurrencyOfsquareSpaceWithExchangeRateCurrency(id: string) {
    const httpOptions = this.RequestHeaders();
    const method: string = `/fetch-store-currency-with-exchangeRate/${id}`;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get(url, httpOptions)
  }

  public syncWithSquareSpace(id: string, storePageId: string, productId: string, consignmentId: string, isManualRate: boolean): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const method: string = `/site/${id}/store-page/${storePageId}/gallery-products/${productId}/consignments/${consignmentId}/sync?IsManualRate=${isManualRate}`
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.post<ResponseObject>(url, {}, httpOptions);
  }

  public syncArtistProductWithSquareSpace(id: string, storePageId: string, productId: string, isManualRate: boolean): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const method: string = `/site/${id}/store-page/${storePageId}/artist-products/${productId}/sync?IsManualRate=${isManualRate}`;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.post<ResponseObject>(url, {}, httpOptions);
  }

  public deleteSquareSpaceSyncProduct(id: string[] | null): Observable<ResponseObject> {
    const httpOptions = {
      ...this.RequestHeaders(),
      body: {
        productSyncedOnPlatformIds: id
      }
    };
    const method: string = '/synced-products';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.delete<ResponseObject>(url, httpOptions);
  }


}
